
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Dot, ListTile, Color } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Dot`}</h1>
<p>{`Used to display a status in a minimal way. Can be used on its own or combined with text when using `}<inlineCode parentName="p">{`ListTile`}</inlineCode>{`.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Dot } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<Dot />`} component={Dot} mdxType="Playground">
  <Dot mdxType="Dot" />
</Playground>
<p>{`If you want to create a status`}</p>
<Playground __position={1} __code={`<ListTile title="Finished" leading={<Dot color={Color.GREEN} />} />`} mdxType="Playground">
  <ListTile title="Finished" leading={<Dot color={Color.GREEN} mdxType="Dot" />} mdxType="ListTile" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;